export default __webpack_public_path__ + "static/getStarted2-f91e44a1abfa035e19d2bc611f053d72.png";